import BreadCrumb from "@/components/BreadCrumb.vue";
export default {
  components: {
    BreadCrumb
  },
  setup() {
    const menus = [];
    return {
      menus
    };
  },
  mounted() {}
};